import React from 'react'
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import AboutAnabel from './AboutAnabel';
function AboutUsIndex() {
  return (
    <div>
      <Navbar />
      <AboutAnabel />
      <Footer />
    </div>
  )
}

export default AboutUsIndex
